module.exports = __webpack_public_path__ + "static/media/charts.2bdae625.png";